import FollowupDashboard from "../../components/FollowupDashboard";

export default function MyLeads() {
  return <FollowupDashboard admin={false} />;
}
